module.exports = __webpack_public_path__ + "static/img/cc_02.c59cb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/cc_02.png
// module id = vLmd
// module chunks = 0